/*!
 * ETAR theme v4.2.4 — Build a gift box
 * Developed by FACTICIED · https://www.facticied.com
 */
(function () {
  if (customElements.get('et-giftbox')) return;
  function money(cents, fmt) {
    fmt = fmt || '{{amount}}';
    const n = (cents / 100), fix = (d, t, dec) => { const p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? dec + p[1] : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? fix(0, ',', '.') : k === 'amount_with_comma_separator' ? fix(2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? fix(0, '.', ',') : fix(2, ',', '.'));
  }
  customElements.define('et-giftbox', class extends HTMLElement {
    connectedCallback() {
      this.max = +this.dataset.slots || 3;
      this.picked = [];
      this.slots = Array.from(this.querySelectorAll('[data-slot]'));
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-pick]');
        if (b) return this.toggle(b);
        const s = e.target.closest('[data-slot].is-full');
        if (s) { const i = this.slots.indexOf(s); const pb = this.picked[i]; if (pb) this.toggle(pb.btn); }
        if (e.target.closest('[data-add]')) this.add();
      });
      this.render();
    }
    toggle(btn) {
      const i = this.picked.findIndex((p) => p.btn === btn);
      if (i > -1) this.picked.splice(i, 1);
      else {
        if (this.picked.length >= this.max) { this.bump(); return; }
        this.picked.push({ btn, id: btn.dataset.pick, price: +btn.dataset.price || 0, img: btn.dataset.img, title: btn.dataset.title });
      }
      this.render();
    }
    bump() { const st = this.querySelector('[data-status]'); st.classList.remove('is-bump'); void st.offsetWidth; st.classList.add('is-bump'); }
    render() {
      const fmt = this.dataset.money;
      this.querySelectorAll('[data-pick]').forEach((b) => {
        const on = this.picked.some((p) => p.btn === b);
        b.setAttribute('aria-pressed', on); b.classList.toggle('is-on', on);
      });
      this.slots.forEach((s, i) => {
        const p = this.picked[i];
        const had = s.classList.contains('is-full');
        s.classList.toggle('is-full', !!p);
        const old = s.querySelector('.et-gb__slot-img'); if (old) old.remove();
        if (p) {
          let el;
          if (p.img) { el = document.createElement('img'); el.src = p.img; el.alt = p.title; }
          else { const svg = p.btn.querySelector('.et-gb__thumb svg'); el = svg ? svg.cloneNode(true) : document.createElement('span'); }
          el.classList.add('et-gb__slot-img');
          s.appendChild(el);
          if (!had) { s.classList.remove('is-drop'); void s.offsetWidth; s.classList.add('is-drop'); }
        }
      });
      const left = this.max - this.picked.length, st = this.querySelector('[data-status]');
      st.textContent = left > 0 ? (st.dataset.left || '').replace('[n]', left) : st.dataset.full;
      this.classList.toggle('is-ready', left === 0);
      let total = this.picked.reduce((a, p) => a + p.price, 0);
      if (this.dataset.box && this.picked.length) total += +this.dataset.boxPrice || 0;
      this.querySelector('[data-total]').textContent = money(total, fmt);
      this.querySelector('[data-add]').disabled = left !== 0 || this.picked.some((p) => !p.id);
    }
    async add() {
      const btn = this.querySelector('[data-add]'), msg = this.querySelector('[data-msg]');
      const items = this.picked.map((p) => ({ id: +p.id, quantity: 1, properties: { 'Gift box': 'Yes' } }));
      if (this.dataset.box) items.push({ id: +this.dataset.box, quantity: 1 });
      btn.disabled = true; btn.classList.add('is-loading');
      const R = window.EtarRoutes || {};
      try {
        const res = await fetch((R.cartAdd || '/cart/add').replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || res.status); }
        const cart = await (await fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('et:cart:updated', { detail: cart }));
        if (!(window.EtarCart && window.EtarCart.afterAdd && window.EtarCart.afterAdd(cart, btn))) msg.textContent = btn.dataset.added;
        this.picked = []; this.render();
      } catch (err) {
        msg.textContent = String(err.message || 'Something went wrong. Please try again.');
        btn.disabled = false;
      } finally { btn.classList.remove('is-loading'); }
    }
  });
})();
